import { Component, OnInit } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { General_Config } from '../General_Config';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { ActivatedRoute } from '@angular/router';
import { ChartType } from "angular-google-charts";
import { AlertController } from '@ionic/angular';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {
  ngOnInit() {
  }

  ionViewWillEnter() {
    this.menuCtrl.enable(true);
    this.loadData();
  }

  code: string = '';
  isopen: boolean = true;
  isopenactual: boolean = true;
  yearlysale = {
    title: 'Yearly sales',
    type: ChartType.PieChart,
    data: [
      ['London', 8136000],
      ['New York', 8538000],
      ['Paris', 2244000],
      ['Berlin', 3470000],
      ['Kairo', 19500000],
    ], myOptions: {
      is3D: true,
    }
  };
  monthlysales = {
    title: 'Sales by month',
    type: ChartType.Bar,
    data: [
      ['London', 8],
      ['New York', 85],
      ['Paris', 22],
      ['Berlin', 34],
      ['Kairo', 19],
    ], myOptions: {
      is3D: true,
      title: 'Sales by month',
    }
  };
  newOrders: any = [];
  counts: any = [];
  isLoading: boolean = true;
  constructor(public menuCtrl: MenuController, private callNumber: CallNumber, public alertController: AlertController, private activatedRoute: ActivatedRoute, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) {
    General_Config.active_page = 'Dashboard';
  }

  loadData() {
    this.restApi.get('shopadmin_dashboard').subscribe((data: any) => {
      this.isLoading = false;
      if (data['code'] == 200) {
        General_Config.active_page = 'Dashboard - ' + data['data']['shop'];
        this.yearlysale.data = data['data']['yearlysales'];
        this.monthlysales.data = data['data']['monthlysales'];
        this.newOrders = data['data']['neworders'];
        this.counts = data['data']['counts'];
        if (data['data']['isopen'] == 1) {
          this.isopen = true;
          this.isopenactual = true;
        } else {
          this.isopen = false;
          this.isopenactual = false;
        }
      }
    }, (error: any) => {
      this.isLoading = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  async acceptOrder(code) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: "Confirmation",
      message: "Do you want to change the sataus as accepted?",
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Confirm No');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            this.isLoading = true;
            this.restApi.put('change_order_status', { code: code, status: 'accepted' }).subscribe((data: any) => {
              this.isLoading = false;
              if (data['code'] == 200) {
                this.loadData();
              }
              this.commonFunctions.presentAlertConfirm('Information', data['message']);
            }, (error: any) => {
              this.isLoading = false;
              this.commonFunctions.presentAlertConfirm('Information', error);
            });
          }
        }
      ]
    });
    await alert.present();
  }

  async changeOpenStatus() {
    if (this.isopenactual !== this.isopen) {
      let status = this.isopen;
      let status_db = 0;
      let status_txt = 'close';
      if (status == true) {
        status_txt = 'open';
        status_db = 1;
      }
      const alert = await this.alertController.create({
        cssClass: 'my-custom-class',
        header: "Confirmation",
        message: "Are you sure to change your shop status as " + status_txt + "?",
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
              this.isopen = this.isopenactual;
              console.log('Confirm No');
            }
          },
          {
            text: 'Yes',
            handler: () => {
              this.isLoading = true;
              this.restApi.put('change_shop_open_status', { status: status_db }).subscribe((data: any) => {
                this.isLoading = false;
                this.loadData();
                this.commonFunctions.presentAlertConfirm('Information', data['message']);
              }, (error: any) => {
                this.isLoading = false;
                this.commonFunctions.presentAlertConfirm('Information', error);
              });
            }
          }
        ]
      });
      await alert.present();
    }
  }

  async rejectOrder(code) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Reject reason',
      inputs: [
        {
          name: 'reason',
          type: 'textarea',
          placeholder: 'Reason'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Reject',
          handler: (input) => {
            if (input.reason !== '') {
              this.isLoading = true;
              this.restApi.put('reject_order', { code: code, reject_reason: input.reason }).subscribe((data: any) => {
                this.isLoading = false;
                if (data['code'] == 200) {
                  this.loadData();
                }
                this.commonFunctions.presentAlertConfirm('Information', data['message']);
              }, (error: any) => {
                this.isLoading = false;
                this.commonFunctions.presentAlertConfirm('Information', error);
              });
            } else {
              return false;
            }
          }
        }
      ]
    });
    await alert.present();
  }

  makeCall(phno) {
    this.callNumber.callNumber(phno, true)
      .then(res => console.log('Launched dialer!', res))
      .catch(err => console.log('Error launching dialer', err));
  }

}
